const FunzionarioStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Compila i seguenti campi",
                id: "funzionarioForm",
                description: "Sezione dedicata al funzionario e alle prime analisi",
                multipleValue: false,
                rows : [
                {
                    id : "row1",
                    fields : [
                        {
                            name: "divisionBar",
                            type: "bar",
                            numColMd: 12,
                            label: "state to funz",
                            tooltipText: "",
                            required: false,
                        }
                    ]
                },
                {
                    id : "row2",
                    fields : [
                        {
                            name: "firstRowDescription",
                            type: "firstRow",
                            numColMd: 12,
                            label: "",
                            required: false,
                            tooltipText: "",
                            
                        }
                    ]
                },
                {
                    id : "row3",
                    fields : [
                        {
                            name: "SecondRowDescription",
                            type: "secondRow",
                            numColMd: 8,
                            label: "Ruolo",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "progressDate",
                            type: "date",
                            numColMd: 2,
                            label: "Data di Avanzamento",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "esitoPropostoString",
                            type: "choice",
                            numColMd: 2,
                            label: "Esito Proposto",
                            required: false,
                            tooltipText: "",
                            choiceList : ["Avvio","Non Avvio","Altro"],
                        },
                    ]
                },
                {
                    id : "row4",
                    fields : [
                        {
                            name: "noteFunzionarioNotediTrasmissione",
                            type: "textArea",
                            numColMd: 12,
                            label: "Note Funzionario / Nota di Trasmissione (Obbligatorio)",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                },
                {
                    id : "row5",
                    fields : [
                        {
                            name: "noteLoi",
                            type: "textAreaLoi",
                            numColMd: 12,
                            label: "Note Loi",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                }
            ]}  
        }
    }
}

export default FunzionarioStructure;